import WishListModal from '@components/modules/WishList/WishListModal'
import Modal from '@components/ui/Modal'
import AddressModal from '@components/ui/Modal/Account/AddressModal'
import ResetPasswordModal from '@components/ui/Modal/Account/ResetPasswordModal'
import MarketSelection from '@components/ui/Modal/Country/MarketSelection'

import DeleteAccountModal from '@components/ui/Modal/Account/DeleteAccountModal'
import { ProductDetailFragment } from '@lib/graphql/graphql'
import { selectCalloutBanner } from '@redux/globalSlice'
import {
  closeModal,
  selectDisplayModal,
  selectModalView,
} from '@redux/modalSlice'
import { useAppDispatch } from '@redux/store'
import { default as clsx, default as cn } from 'clsx'
import React, { CSSProperties, FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { HeaderData } from 'types/header'
import { Page } from 'types/page'
import Footer, { FooterProps } from '../Footer/footer'
import Navbar from '../NavbarV2/Navbar'
import OverlayHandler from '../Overlay/Overlay'
import s from './Layout.module.scss'

const ModalView: FC<{ modalView: string }> = ({ modalView }) => {
  const dispatch = useAppDispatch()
  const [onClose, setOnClose] = useState<() => void>(() => {})

  useEffect(() => {
    setOnClose(() => () => dispatch(closeModal()))
  }, [modalView, dispatch])

  const forceAction = modalView === 'MARKET_MATCHING_MODAL'
  return (
    <Modal forceAction={forceAction} onClose={onClose} setOnClose={setOnClose}>
      {modalView === 'MARKET_SELECTION' && <MarketSelection />}
      {modalView === 'SHARE_WISHLIST' && <WishListModal />}
      {modalView === 'ADDRESS_MODAL' && <AddressModal />}
      {modalView === 'RESET_PASSWORD_MODAL' && <ResetPasswordModal />}
      {modalView === 'DELETE_ACCOUNT_MODAL' && (
        <DeleteAccountModal onClose={onClose} />
      )}
    </Modal>
  )
}

const ModalUI: FC = () => {
  const modalView = useSelector(selectModalView)
  const displayModal = useSelector(selectDisplayModal)
  return displayModal ? <ModalView modalView={modalView} /> : null
}

export type PageProps = {
  pageProps: {
    page: Page
    country: string
    productV2?: ProductDetailFragment
  }
  footer?: FooterProps
  header?: HeaderData
  children?: React.ReactNode
}

const Layout: FC<PageProps> = ({
  children,
  pageProps,
  header,
  footer,
  ...args
}) => {
  const calloutBanner = useSelector(selectCalloutBanner)

  return (
    <div
      data-header-space={!!pageProps.page?.headerSpace}
      className={clsx(s.root, 'relative')}
      style={
        {
          '--top-nav-height': `calc(var(--header-height) + ${
            calloutBanner ? `32px` : `0px`
          })`,
        } as CSSProperties
      }
    >
      <Navbar headerSpace={pageProps.page?.headerSpace} />
      {/* <Navbar {...args} headerSpace={pageProps.page?.headerSpace} />
       */}
      {/* {basketOpen && <Basket />}
      {searchOpen && <Search />} */}
      <main
        style={
          {
            '--bg-image':
              pageProps.page?.pageBackgroundImage?.url &&
              `url('${pageProps.page?.pageBackgroundImage?.url}')`,
            '--bg-color': pageProps.page?.pageBackgroundColor,
            '--foreground-color': pageProps.page?.pageFontColor,
            justifyContent: pageProps.page?.pageCenterItems
              ? 'center'
              : undefined,
          } as React.CSSProperties
        }
        className={cn('fit relative', s.main)}
        id="sublime-main"
      >
        {/* Do not remove this*/}
        <div className="site-wrapper">{children}</div>
      </main>

      <OverlayHandler />
      {!pageProps.page?.disableFooter && <Footer />}
      <ModalUI />
    </div>
  )
}

export default Layout
